module.exports = __webpack_public_path__ + "static/05-f772a8dd0cd5a2c7208a12338030e30a.jpg";